<ng-container *ngIf="value != undefined && value != null">
    <i class="pi pi-circle-on" [pTooltip]="value ? 'Eliminato' : 'Attivo'"
        [style]="   { color: value ?  '#bd383e' : '#15d151', fontSize: '1rem', border:'1px solid black', borderRadius:'15px' }    "></i>
</ng-container>